import { SpriteSymbol } from "@/assets/icons/sprite/IconSprite";
import { IconProps } from "@/common/contracts/icon.contracts";

type SpriteIconProps = {
  symbol: SpriteSymbol;
} & IconProps;

/**
 * An `<svg>` that draws one of the sprite's symbols. Callers pass the exact
 * outer attributes their inline version had (`width`, `height`, `fill`,
 * `xmlns`, `className`, ...), so an icon converted to the sprite renders with
 * the same box, the same size classes and the same `currentColor` behaviour as
 * before. Only the path data moves, into `<IconSprite />`.
 */
export const SpriteIcon = ({ symbol, ...props }: SpriteIconProps) => {
  return (
    <svg viewBox={symbol.viewBox} {...props}>
      <use href={`#${symbol.id}`} />
    </svg>
  );
};
